export interface UpdateAnnualReportTemplateTranslation {
    name: string;
    caption: Record<string, string>;
}
